import type { ILockItem } from '@tencent/ark-lock/lib/types/src/config';
import type { IDisposable } from '@tencent/dispose-tree';

/**
 * 通用返回结果类型
 *
 * @class Result
 * @template T
 */
declare class Result<T = any> {
    error?: Error;
    data: T;
    constructor(error?: Error, data?: T);
}

/**
 * 对外暴露的锁接口
 *
 * @export
 * @interface ILock
 */
export interface ILock {
    lock(key: string, optional: LockKeyParams): Promise<ILockResult>;
    release(key: string): Promise<boolean>;
    detectKey(key: string): Promise<Result<undefined | ILockItem>>;
}

/**
 * 上锁返回的结果信息
 *
 * @export
 * @interface LockResult
 */
export interface ILockResult {
    isSuccess: boolean;
    data: ILockItem;
}
export type CallbackFunction = (param: unknown) => void;
export type LockKeyParams = {
    [key: string]: string;
};

// 探测锁成功时回调
export type DetectLockSuccessCallBack = () => void;

/**
 * 编辑互斥锁状态
 *
 */
export enum MutexLockState {
    /**
     * 初始化
     */
    INIT = 'INIT',
    /**
     * 锁失败
     */
    FAILED = 'FAILED',
    /**
     * 锁成功
     */
    SUCCESS = 'SUCCESS',
    /**
     * 锁已释放
     */
    RELEASE = 'RELEASE',
}

export interface IMutexLockHelper extends IDisposable {
    /**
     * 上一次探测锁失败时锁持有者信息
     *
     * @type {ILockItem}
     */
    lastLockItem?: ILockItem;

    /**
     * 上锁
     *
     * @returns {Promise<boolean>}
     */
    lock(): Promise<boolean>;

    /**
     * 是否上锁
     *
     * @return {*}  {boolean}
     */
    isLocked(): boolean;

    /**
     * 是否被其他页上锁
     */
    isLockedByOtherPage(): boolean;

    /**
     * 持续探测，申请锁
     *
     * @param {DetectLockSuccessCallBack} detectLockCb
     * @param {number} [interval]
     */
    detect(detectLockCb: DetectLockSuccessCallBack, interval?: number): void;

    /**
     * 释放锁
     *
     * @return {*}  {Promise<boolean>}
     */
    release(): Promise<boolean>;

    /**
     * 获取锁状态
     */
    getLockState(): MutexLockState;
}

export enum MutexLockSource {
    /**
     * 详情页
     */
    EDIT = 'edit',
    /**
     * 预加载服务或者列表页
     */
    LIST = 'list',
}
